import React from 'react';

import styles from './styles.module.css';
import emptyContainer from '#/assets/img/empty-container.svg';

import { useTranslation } from "react-i18next";


function EmptyContainer() {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper} data-testid="empty-container">
      <img
        className={styles.image}
        src={emptyContainer}
        alt={t('EMPTY_DASHBOARD')}
      />
      <p className={styles.paragraph}>
        {t('NO_WIDGETS')}
      </p>
      <p className={styles.paragraph}>
        {t('CLICK_ON')} <b>{t('EDIT')}</b> {t('TO_START_EDITING_YOUR_DASHBOARD')}
      </p>
    </div>
  );
}

export default EmptyContainer;
